"use client";
import React, { useEffect, useState } from "react";

import OnboardingLayout from "../../layouts/Onboarding";
import { useNavigate } from "react-router-dom";
import TwoFAQrCode from "../../components/QrCodeTwoFA";
import { useAuth } from "../../context/AuthContext";
import Toaster from "../../components/ui/toaster";
import { enable2FA, verify2FA } from "../../services/digitalWalletService";
import { useToast } from "../../hooks/use-toast";
import AuthenticateTwoFA from "../../components/AuthenticateTwoFA";
export default function TwoFAPage({ closeOverlay }) {
  const navigate = useNavigate();
  const { settings, updateSettings, refreshUser } = useAuth();
  const { toast } = useToast();
  const [authenticate, setAuthenticate] = useState(false);
  const [mainSecret, setMainSecret] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  useEffect(() => {
    const enable = settings?.security?.twoFactorAuth?.enabled;
    if (enable === true) {
      setAuthenticate(true);
    }
    setIsEnabled(enable || false);
  }, [settings]);

  const handleNext = (secret) => {
    setMainSecret(secret);
    setAuthenticate(true);
  };

  const handleVerify = async (token) => {
    try {
      const otpauthUrl = `otpauth://totp/80Eight?secret=${mainSecret}`;
      const result = isEnabled
        ? await verify2FA({ token })
        : await enable2FA({ token, secret: mainSecret, otpauthUrl });

      if (result) {
        if (result?.data?.data) {
          updateSettings(result.data.data);
        }
        await refreshUser();
        toast({
          description: `2FA ${isEnabled ? "verified" : "enabled"} Successfully`,
          variant: "eighty",
        });
        navigate("/trading/digitalWallet");
      }
    } catch (error) {
      toast({
        description: `${error.message}`,
        variant: "eighty",
      });
    }
  };
  const close = () => {
    navigate(-1);
  };

  return (
    <OnboardingLayout close={close}>
      <Toaster />
      {isEnabled === false && authenticate === false && (
        <div className="min-w-[100px]">
          {" "}
          <TwoFAQrCode onNext={handleNext} />
        </div>
      )}
      {authenticate === true && <AuthenticateTwoFA onVerify={handleVerify} />}
    </OnboardingLayout>
  );
}
